module.exports = __webpack_public_path__ + "img/bg10.bacc403a.jpg";